(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3954],{

/***/ 12912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CA": function() { return /* binding */ CompanyHead; },
/* harmony export */   "HG": function() { return /* binding */ SearchCompaniesHead; },
/* harmony export */   "SG": function() { return /* binding */ OverseasCompanyHead; },
/* harmony export */   "UJ": function() { return /* binding */ DefaultHead; },
/* harmony export */   "WD": function() { return /* binding */ ArticlesHead; },
/* harmony export */   "cm": function() { return /* binding */ NewTagHead; },
/* harmony export */   "dh": function() { return /* binding */ SearchHead; },
/* harmony export */   "hw": function() { return /* binding */ InvestorHead; },
/* harmony export */   "iG": function() { return /* binding */ NoticeHead; },
/* harmony export */   "ls": function() { return /* binding */ ArticleHead; },
/* harmony export */   "sD": function() { return /* binding */ RoundsHead; },
/* harmony export */   "tk": function() { return /* binding */ SearchInvestorsHead; },
/* harmony export */   "vB": function() { return /* binding */ FeaturedHead; },
/* harmony export */   "yU": function() { return /* binding */ StatusSettingHead; }
/* harmony export */ });
/* unused harmony exports SeminarHead, CircleHead */
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _lib_url__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48261);




var DefaultHead = function(param) {
    var _title = param.title, title = _title === void 0 ? "スピーダ スタートアップ情報リサーチ" : _title, _description = param.description, description = _description === void 0 ? "スタートアップ投資や協業を成功させるために、事業内容・資金調達状況・提携先・関連ニュース・投資家情報・分析レポートなどの検索から取得管理までシームレスに行える情報プラットフォームです。" : _description, _image = param.image, image = _image === void 0 ? "".concat(_lib_url__WEBPACK_IMPORTED_MODULE_2__/* .host */ .ho, "/static/images/ogp.png") : _image, _url = param.url, url = _url === void 0 ? "https://initial.inc/" : _url, _twitterCard = param.twitterCard, twitterCard = _twitterCard === void 0 ? "summary_large_image" : _twitterCard, children = param.children;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                name: "keywords",
                content: "スピーダ,スタートアップ,NewsPicksスタートアップ,startup,ベンチャー"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:url",
                content: url
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:image",
                content: image
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:site_name",
                content: "スピーダ スタートアップ情報リサーチ"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                name: "twitter:card",
                content: twitterCard
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                name: "twitter:site",
                content: "@".concat(_lib_url__WEBPACK_IMPORTED_MODULE_2__/* .twitterUserName */ .IR)
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                name: "twitter:creator",
                content: "@".concat(_lib_url__WEBPACK_IMPORTED_MODULE_2__/* .twitterUserName */ .IR)
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                name: "twitter:url",
                content: url
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                name: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                name: "twitter:image",
                content: image
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("link", {
                rel: "canonical",
                href: url
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                name: "viewport",
                content: "width=device-width,height=device-height"
            }, "viewport"),
            children
        ]
    });
};
var ArticlesHead = function() {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(DefaultHead, {
        title: "オリジナル記事｜スピーダ スタートアップ情報リサーチ",
        description: "スピーダ スタートアップ情報リサーチのオリジナル記事はこちら",
        url: _lib_url__WEBPACK_IMPORTED_MODULE_2__/* .articlesUrl */ .LT
    });
};
var ArticleHead = function(param) {
    var article = param.article;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(DefaultHead, {
        title: "".concat(article.title, "｜スピーダ スタートアップ情報リサーチ"),
        description: article.introduction,
        url: (0,_lib_url__WEBPACK_IMPORTED_MODULE_2__/* .articleUrl */ .MG)(article),
        image: article.headerImage.url,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("script", {
            dangerouslySetInnerHTML: {
                __html: JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "Article",
                    headline: article.title,
                    image: [
                        article.headerImage.url
                    ],
                    datePublished: article.publishedAt
                })
            },
            type: "application/ld+json"
        })
    });
};
var SeminarHead = function(param) {
    var seminar = param.seminar;
    return /*#__PURE__*/ _jsx(DefaultHead, {
        title: "".concat(seminar.title, "｜スピーダ スタートアップ情報リサーチ"),
        description: seminar.introduction,
        url: seminarUrl(seminar.slug),
        image: seminar.headerImage.url
    });
};
var NewTagHead = function(param) {
    var tag = param.tag;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(DefaultHead, {
        title: "".concat(tag.name, "｜スピーダ スタートアップ情報リサーチ"),
        url: (0,_lib_url__WEBPACK_IMPORTED_MODULE_2__/* .newTagUrl */ .Cc)(tag),
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
            name: "viewport",
            content: "width=1200px"
        }, "viewport")
    });
};
var CompanyHead = function(param) {
    var company = param.company, children = param.children;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(DefaultHead, {
        title: "".concat(company.name, "｜スピーダ スタートアップ情報リサーチ"),
        description: company.description,
        url: (0,_lib_url__WEBPACK_IMPORTED_MODULE_2__/* .companyUrl */ .c2)(company),
        image: company.imageUrl,
        twitterCard: company.imageUrl ? "summary" : undefined,
        children: children
    });
};
var OverseasCompanyHead = function(param) {
    var company = param.company, children = param.children;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(DefaultHead, {
        title: "".concat(company.name, "｜スピーダ スタートアップ情報リサーチ"),
        description: company.description || "",
        children: children
    });
};
var InvestorHead = function(param) {
    var investor = param.investor;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(DefaultHead, {
        title: "".concat(investor.name, "｜スピーダ スタートアップ情報リサーチ"),
        description: investor.description,
        url: (0,_lib_url__WEBPACK_IMPORTED_MODULE_2__/* .investorUrl */ .J4)(investor.shortname),
        image: investor.imageUrl,
        twitterCard: investor.imageUrl ? "summary" : undefined
    });
};
var FeaturedHead = function(param) {
    var featured = param.featured;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(DefaultHead, {
        title: "".concat(featured.title, "｜スピーダ スタートアップ情報リサーチ"),
        description: featured.description,
        url: (0,_lib_url__WEBPACK_IMPORTED_MODULE_2__/* .featuredUrl */ .Qu)(featured.slug),
        image: featured.ogpImage.url
    });
};
var SearchHead = function() {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(DefaultHead, {
        title: "検索｜スピーダ スタートアップ情報リサーチ",
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
            name: "viewport",
            content: "width=1200px"
        }, "viewport")
    });
};
var RoundsHead = function() {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(DefaultHead, {
        title: "資金調達検索｜スピーダ スタートアップ情報リサーチ",
        description: "スピーダ スタートアップ情報リサーチの資金調達検索はこちら"
    });
};
var StatusSettingHead = function() {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(DefaultHead, {
        title: "ステータス設定｜スピーダ スタートアップ情報リサーチ",
        description: "スピーダ スタートアップ情報リサーチのステータス設定についてはこちら"
    });
};
var NoticeHead = function(param) {
    var notice = param.notice;
    var ref;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(DefaultHead, {
        title: "".concat(notice.title, "｜スピーダ スタートアップ情報リサーチ"),
        image: notice.headerImage.url,
        description: (ref = notice.body) === null || ref === void 0 ? void 0 : ref.slice(0, 100),
        url: notice.slug ? _lib_url__WEBPACK_IMPORTED_MODULE_2__/* .host */ .ho + (0,_lib_url__WEBPACK_IMPORTED_MODULE_2__/* .noticePath */ .$t)(notice.slug) : _lib_url__WEBPACK_IMPORTED_MODULE_2__/* .host */ .ho
    });
};
var SearchCompaniesHead = function() {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(DefaultHead, {
        title: "スタートアップ｜スピーダ スタートアップ情報リサーチ",
        description: "スピーダ スタートアップ情報リサーチのスタートアップ企業検索はこちら",
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
            name: "viewport",
            content: "width=1200px"
        }, "viewport")
    });
};
var SearchInvestorsHead = function() {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(DefaultHead, {
        title: "投資家｜スピーダ スタートアップ情報リサーチ",
        description: "スピーダ スタートアップ情報リサーチの投資家検索はこちら"
    });
};
var CircleHead = function() {
    return /*#__PURE__*/ _jsx(DefaultHead, {
        title: "ユーザーコミュニティ「INITIAL Circle」｜INITIAL",
        description: "INITIALユーザーの知見と人脈をつなぎ、循環させるためのユーザーコミュニティ「INITIAL Circle」。INITIALを利用する、VC、CVC、事業会社、行政、金融、研究機関、スタートアップのみなさんが、所属する組織や地域、立場の垣根を超えて、自由に交流する場です。",
        url: enterpriseCircleUrl,
        image: "".concat(host, "/static/images/enterprise/index/ogp_enterprise.png")
    });
};


/***/ }),

/***/ 58585:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ getFeatured; },
/* harmony export */   "A5": function() { return /* binding */ getArticlesByInvestor; },
/* harmony export */   "AU": function() { return /* binding */ getArticlesByKeyword; },
/* harmony export */   "BB": function() { return /* binding */ getArticlesByCompany; },
/* harmony export */   "Hp": function() { return /* binding */ getFeaturedByArticle; },
/* harmony export */   "Jo": function() { return /* binding */ getEnterpriseNotices; },
/* harmony export */   "Od": function() { return /* binding */ getArticlesByTag; },
/* harmony export */   "R9": function() { return /* binding */ getFeaturedList; },
/* harmony export */   "T4": function() { return /* binding */ getNpStartupFloatingBanner; },
/* harmony export */   "V6": function() { return /* binding */ getNpStartupSlideBannerArticles; },
/* harmony export */   "Vb": function() { return /* binding */ getContentfulInvestor; },
/* harmony export */   "Zz": function() { return /* binding */ getArticles; },
/* harmony export */   "ex": function() { return /* binding */ getPreviewArticle; },
/* harmony export */   "fq": function() { return /* binding */ getArticle; },
/* harmony export */   "gS": function() { return /* binding */ getNewTag; },
/* harmony export */   "kf": function() { return /* binding */ getContentfulCompany; },
/* harmony export */   "pN": function() { return /* binding */ notPublishedYet; },
/* harmony export */   "r7": function() { return /* binding */ getNotices; },
/* harmony export */   "re": function() { return /* binding */ filterPublished; },
/* harmony export */   "uT": function() { return /* binding */ getNotice; },
/* harmony export */   "yy": function() { return /* binding */ getNpStartupStaticBanner; }
/* harmony export */ });
/* unused harmony exports getArticleBySlug, getArticleById, getPreviewArticleBySlug, getPreviewArticleById, articlesPageLimit, getSeminar, getPickupArticles, getSubPickups, getNewPickups, getGlobalFinanceNews, getNoticeById, getNoticeBySlug, getInsight, getTagRanking, getContentType */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70655);
/* harmony import */ var contentful__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10159);
/* harmony import */ var lodash_uniqWith__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87185);
/* harmony import */ var lodash_uniqWith__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_uniqWith__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _article__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9427);
/* harmony import */ var _date__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(57923);
/* harmony import */ var _browser__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38387);
/* harmony import */ var _log__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(79240);














var client = function() {
    var client;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_browser__WEBPACK_IMPORTED_MODULE_4__/* .isBrowser */ .jU ? [
        "report-api.ub-speeda.com",
        false
    ] : [
        "report-api.ub-speeda.lan",
        true
    ], 2), host = ref[0], insecure = ref[1];
    return function() {
        if (!client) {
            client = contentful__WEBPACK_IMPORTED_MODULE_0__/* .createClient */ .e({
                space: "bdepgd648nl9",
                accessToken: "SECRET",
                environment: "master",
                host: host,
                insecure:  true ? insecure : 0
            });
        }
        return client;
    };
}();
var previewClient = function() {
    var client;
    return function() {
        if (!client) {
            client = contentful__WEBPACK_IMPORTED_MODULE_0__/* .createClient */ .e({
                space: "bdepgd648nl9",
                accessToken: "SECRET",
                environment: "master",
                host: "preview.report-api.ub-speeda.com",
                insecure: false
            });
        }
        return client;
    };
}();
var getArticle = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(slugOrId) {
        var _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getArticleBySlug(slugOrId)
                    ];
                case 1:
                    _tmp = _state.sent();
                    if (_tmp) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        getArticleById(slugOrId)
                    ];
                case 2:
                    _tmp = _state.sent();
                    _state.label = 3;
                case 3:
                    return [
                        2,
                        _tmp
                    ];
            }
        });
    });
    return function getArticle(slugOrId) {
        return _ref.apply(this, arguments);
    };
}();
var getArticleBySlug = function(slug) {
    return client().getEntries({
        include: 2,
        content_type: "article",
        "fields.slug": slug
    }).then(function(response) {
        if (response.items.length > 0) {
            var entry = response.items[0];
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, entry.fields), {
                id: entry.sys.id
            });
        } else {
            return;
        }
    }).catch(function(err) {
        throw err;
    });
};
var getArticleById = function(id) {
    return client().getEntries({
        include: 2,
        "sys.id": id
    }).then(function(response) {
        if (response.items.length > 0) {
            var entry = response.items[0];
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, entry.fields), {
                id: entry.sys.id
            });
        } else {
            return;
        }
    }).catch(function(err) {
        throw err;
    });
};
var getPreviewArticle = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(slugOrId) {
        var _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getPreviewArticleBySlug(slugOrId)
                    ];
                case 1:
                    _tmp = _state.sent();
                    if (_tmp) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        getPreviewArticleById(slugOrId)
                    ];
                case 2:
                    _tmp = _state.sent();
                    _state.label = 3;
                case 3:
                    return [
                        2,
                        _tmp
                    ];
            }
        });
    });
    return function getPreviewArticle(slugOrId) {
        return _ref.apply(this, arguments);
    };
}();
var getPreviewArticleBySlug = function(slug) {
    return previewClient().getEntries({
        include: 2,
        content_type: "article",
        "fields.slug": slug
    }).then(function(response) {
        if (response.items.length > 0) {
            var entry = response.items[0];
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, entry.fields), {
                id: entry.sys.id
            });
        } else {
            return;
        }
    }).catch(function(err) {
        throw err;
    });
};
var getPreviewArticleById = function(id) {
    return previewClient().getEntries({
        include: 2,
        "sys.id": id
    }).then(function(response) {
        if (response.items.length > 0) {
            var entry = response.items[0];
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, entry.fields), {
                id: entry.sys.id
            });
        } else {
            return;
        }
    }).catch(function(err) {
        throw err;
    });
};
var articlesPageLimit = 24;
var getArticles = function() {
    var cursor = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, limit = arguments.length > 1 ? arguments[1] : void 0;
    var options = {
        "fields.publishedAt[lte]": (0,_date__WEBPACK_IMPORTED_MODULE_9__/* .dateInJST */ .WU)(),
        content_type: "article",
        order: "-fields.publishedAt",
        skip: cursor,
        limit: limit || articlesPageLimit
    };
    return client().getEntries(options).then(function(response) {
        return {
            items: response.items,
            total: response.total
        };
    }).catch(_log__WEBPACK_IMPORTED_MODULE_10__/* .printError */ .O);
};
var getArticlesByKeyword = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(keyword) {
        var ref, titleMatch, bodyMatch, introMatch, allMatchArticles, e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        Promise.all([
                            getAritlcesByKeywordOfField("title", keyword),
                            getAritlcesByKeywordOfField("introduction", keyword),
                            getAritlcesByKeywordOfField("body", keyword)
                        ])
                    ];
                case 1:
                    ref = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"].apply */ .Z.apply(void 0, [
                        _state.sent(),
                        3
                    ]), titleMatch = ref[0], bodyMatch = ref[1], introMatch = ref[2];
                    allMatchArticles = lodash_uniqWith__WEBPACK_IMPORTED_MODULE_1___default()((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(titleMatch.items).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(introMatch.items), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(bodyMatch.items)), function(a, b) {
                        return a.sys.id === b.sys.id;
                    });
                    return [
                        2,
                        {
                            items: allMatchArticles,
                            total: allMatchArticles.length
                        }
                    ];
                case 2:
                    e = _state.sent();
                    (0,_log__WEBPACK_IMPORTED_MODULE_10__/* .printError */ .O)(e);
                    return [
                        2
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getArticlesByKeyword(keyword) {
        return _ref.apply(this, arguments);
    };
}();
var getAritlcesByKeywordOfField = function(field, keyword) {
    var LIMIT = 3;
    var options = (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
        "fields.publishedAt[lte]": (0,_date__WEBPACK_IMPORTED_MODULE_9__/* .dateInJST */ .WU)(),
        content_type: "article",
        limit: LIMIT,
        skip: 0
    }, "fields.".concat(field, "[match]"), keyword);
    return client().getEntries(options).then(function(response) {
        return {
            items: response.items,
            total: response.total
        };
    }).catch(function(err) {
        throw err;
    });
};
var getSeminar = function(slug) {
    return client().getEntries({
        content_type: "seminar",
        "fields.slug": slug
    }).then(function(response) {
        if (response.items.length > 0) {
            var entry = response.items[0];
            return _object_spread_props(_object_spread({}, entry.fields), {
                id: entry.sys.id
            });
        } else {
            throw new Error('Contentful: Not found slug="'.concat(slug, '"'));
        }
    }).catch(function(err) {
        throw err;
    });
};
var getPickupArticles = function() {
    return client().getEntries({
        "fields.publishedAt[lte]": dateInJST(),
        content_type: "pickup",
        order: "-fields.publishedAt,sys.id",
        limit: 1,
        include: 2
    }).then(function(response) {
        var articles = response.items.length > 0 ? response.items[0].fields.articles : [];
        // Archiveされた記事を除外する
        return articles.filter(function(obj) {
            return obj.hasOwnProperty("fields");
        });
    }).catch(function(err) {
        throw err;
    });
};
var getSubPickups = function() {
    return client().getEntries({
        "fields.publishedAt[lte]": dateInJST(),
        content_type: "subPickup",
        order: "-fields.publishedAt,sys.id",
        limit: 1,
        include: 2
    }).then(function(response) {
        var items = response.items.length > 0 ? response.items[0].fields.items : [];
        // Archiveされたホワイトペーパーを除外する
        return items.filter(function(obj) {
            return obj.hasOwnProperty("fields");
        });
    }).catch(function(err) {
        throw err;
    });
};
var getNewPickups = function() {
    return client().getEntries({
        content_type: "newPickup",
        order: "-sys.createdAt",
        limit: 1
    }).then(function(response) {
        var articles = response.items[0].fields.articles;
        // Archiveされた記事を除外する
        return articles.filter(function(obj) {
            return obj.hasOwnProperty("fields");
        });
    });
};
var getGlobalFinanceNews = function(limit) {
    return client().getEntries({
        content_type: "globalNews",
        order: "-fields.publishedAt",
        limit: limit
    }).then(function(entries) {
        return entries.items.map(function(item) {
            return _object_spread({}, item.fields);
        });
    });
};
// NOTE: 従来のお知らせと表示方法が異なるのでまずは1件のみ表示
var noticesPageLimit = 1;
var getNotices = function(scopes) {
    var now = (0,_date__WEBPACK_IMPORTED_MODULE_9__/* .dateInJST */ .WU)();
    return client().getEntries({
        "fields.publishedAt[lte]": now,
        "fields.finishedAt[gt]": now,
        "fields.scope[in]": scopes.join(","),
        content_type: "notice",
        order: "-fields.publishedAt",
        limit: noticesPageLimit
    }).then(function(res) {
        return res.items;
    }).catch(function(err) {
        throw err;
    });
};
var getNotice = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(slugOrId) {
        var _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getNoticeBySlug(slugOrId)
                    ];
                case 1:
                    _tmp = _state.sent();
                    if (_tmp) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        getNoticeById(slugOrId)
                    ];
                case 2:
                    _tmp = _state.sent();
                    _state.label = 3;
                case 3:
                    return [
                        2,
                        _tmp
                    ];
            }
        });
    });
    return function getNotice(slugOrId) {
        return _ref.apply(this, arguments);
    };
}();
var getNoticeById = function(id) {
    return client().getEntry(id).then(function(entry) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, entry.fields), {
            id: entry.sys.id
        });
    }).catch(function(err) {
        throw err;
    });
};
var getNoticeBySlug = function(slug) {
    return client().getEntries({
        content_type: "notice",
        "fields.slug": slug
    }).then(function(response) {
        if (response.items.length > 0) {
            var entry = response.items[0];
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, entry.fields), {
                id: entry.sys.id
            });
        } else {
            return;
        }
    }).catch(function(err) {
        throw err;
    });
};
var getEnterpriseNotices = function() {
    var now = (0,_date__WEBPACK_IMPORTED_MODULE_9__/* .dateInJST */ .WU)();
    return client().getEntries({
        "fields.publishedAt[lte]": now,
        "fields.finishedAt[gt]": now,
        content_type: "enterpriseNotice",
        order: "-fields.publishedAt"
    }).then(function(res) {
        return res.items;
    }).catch(function(err) {
        throw err;
    });
};
var getInsight = function(slug) {
    return client().getEntries({
        content_type: "insight",
        "fields.slug": slug
    }).then(function(response) {
        if (response.items.length > 0) {
            var entry = response.items[0];
            var _fields = entry.fields, contenfulRelatedArticles = _fields.relatedArticles, rest = _object_without_properties(_fields, [
                "relatedArticles"
            ]);
            var relatedArticles = contenfulRelatedArticles === null || contenfulRelatedArticles === void 0 ? void 0 : contenfulRelatedArticles.map(function(a) {
                return convertArticle(_object_spread_props(_object_spread({}, a.fields), {
                    id: a.sys.id
                }), true);
            });
            return _object_spread_props(_object_spread({}, rest), {
                relatedArticles: relatedArticles,
                id: entry.sys.id
            });
        } else {
            throw new Error('Contentful: Not found slug="'.concat(slug, '"'));
        }
    }).catch(function(err) {
        throw err;
    });
};
var getArticlesByTag = function(tagId) {
    return client().getEntries({
        "fields.publishedAt[lte]": (0,_date__WEBPACK_IMPORTED_MODULE_9__/* .dateInJST */ .WU)(),
        content_type: "article",
        links_to_entry: tagId,
        order: "-fields.publishedAt"
    }).then(function(response) {
        return {
            items: response.items
        };
    }).catch(function(err) {
        throw err;
    });
};
var getArticlesByCompany = function(companyId) {
    return client().getEntries({
        "fields.publishedAt[lte]": (0,_date__WEBPACK_IMPORTED_MODULE_9__/* .dateInJST */ .WU)(),
        content_type: "article",
        links_to_entry: companyId,
        order: "-fields.publishedAt"
    }).then(function(response) {
        return {
            items: response.items
        };
    }).catch(function(err) {
        throw err;
    });
};
var getArticlesByInvestor = function(investorId) {
    return client().getEntries({
        "fields.publishedAt[lte]": (0,_date__WEBPACK_IMPORTED_MODULE_9__/* .dateInJST */ .WU)(),
        content_type: "article",
        links_to_entry: investorId,
        order: "-fields.publishedAt"
    }).then(function(response) {
        return {
            items: response.items
        };
    }).catch(function(err) {
        throw err;
    });
};
var getContentfulCompany = function(shortname) {
    return client().getEntries({
        content_type: "company",
        "fields.shortname": shortname
    }).then(function(response) {
        var entry = response.items[0];
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, entry.fields), {
            id: entry.sys.id
        });
    }).catch(function(err) {
        throw err;
    });
};
var getContentfulInvestor = function(shortname) {
    return client().getEntries({
        content_type: "investor",
        "fields.shortname": shortname
    }).then(function(response) {
        var entry = response.items[0];
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, entry.fields), {
            id: entry.sys.id
        });
    }).catch(function(err) {
        throw err;
    });
};
var getFeaturedByArticle = function(articleId) {
    return client().getEntries({
        content_type: "featured",
        links_to_entry: articleId
    }).then(function(response) {
        var entry = response.items[0];
        return entry ? (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, entry.fields), {
            id: entry.sys.id
        }) : null;
    }).catch(function(err) {
        throw err;
    });
};
var getNewTag = function(sfdcId) {
    return client().getEntries({
        content_type: "newTag",
        "fields.sfdcId": sfdcId
    }).then(function(response) {
        var entry = response.items[0];
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, entry.fields), {
            id: entry.sys.id
        });
    }).catch(function(err) {
        throw err;
    });
};
var getTagRanking = function() {
    return client().getEntries({
        content_type: "tagRanking"
    }).then(function(response) {
        var entry = response.items[0];
        return _object_spread_props(_object_spread({}, entry.fields), {
            id: entry.sys.id
        });
    }).catch(function(err) {
        throw err;
    });
};
var getFeatured = function(slug) {
    return client().getEntries({
        content_type: "featured",
        "fields.slug": slug,
        include: 2
    }).then(function(response) {
        var entry = response.items[0];
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, entry.fields), {
            id: entry.sys.id
        });
    }).catch(function(err) {
        throw err;
    });
};
var getFeaturedList = function() {
    return client().getEntries({
        "fields.publishedAt[lte]": (0,_date__WEBPACK_IMPORTED_MODULE_9__/* .dateInJST */ .WU)(),
        content_type: "featured",
        order: "-fields.publishedAt"
    }).then(function(res) {
        return res.items.map(function(item) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, item.fields), {
                id: item.sys.id
            });
        });
    }).catch(function(err) {
        throw err;
    });
};
var getNpStartupSlideBannerArticles = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
        var options;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            options = {
                content_type: "npStartupMobileSlideBannerAd",
                order: "-sys.updatedAt",
                limit: 1
            };
            return [
                2,
                client().getEntries(options).then(function(res) {
                    var articleMetas = res.items[0].fields.articles;
                    var articles = articleMetas.map(function(articleMeta) {
                        var article = articleMeta.fields;
                        return {
                            articleUrl: article.articleUrl,
                            articleBannerImageUrl: "https:" + article.articleBannerImageUrl.fields.file.url,
                            newsId: article.newsId ? article.newsId : null
                        };
                    });
                    return articles;
                }).catch(function(err) {
                    (0,_log__WEBPACK_IMPORTED_MODULE_10__/* .printError */ .O)(err);
                    return null;
                })
            ];
        });
    });
    return function getNpStartupSlideBannerArticles() {
        return _ref.apply(this, arguments);
    };
}();
var getNpStartupStaticBanner = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
        var options;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            options = {
                content_type: "npStartupDesktopStaticBannerAd",
                order: "-sys.updatedAt",
                limit: 1
            };
            return [
                2,
                client().getEntries(options).then(function(response) {
                    var articleMetas = response.items[0].fields.articles;
                    var articles = articleMetas.map(function(articleMeta) {
                        var article = articleMeta.fields;
                        return {
                            articleUrl: article.articleUrl,
                            articleBannerImageUrl: "https:" + article.articleBannerImageUrl.fields.file.url,
                            newsId: article.newsId ? article.newsId : null
                        };
                    });
                    return articles;
                }).catch(function(err) {
                    (0,_log__WEBPACK_IMPORTED_MODULE_10__/* .printError */ .O)(err);
                    return null;
                })
            ];
        });
    });
    return function getNpStartupStaticBanner() {
        return _ref.apply(this, arguments);
    };
}();
var getNpStartupFloatingBanner = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
        var options;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            options = {
                content_type: "npStartupDesktopFloatingBannerAd",
                order: "-sys.updatedAt",
                limit: 1
            };
            return [
                2,
                client().getEntries(options).then(function(response) {
                    var articlesResponse = response.items[0].fields.articles;
                    var articles = articlesResponse.map(function(articleResponse) {
                        var article = articleResponse.fields;
                        return {
                            articleUrl: article.articleUrl,
                            articleBannerImageUrl: "https:" + article.articleBannerImageUrl.fields.file.url,
                            newsId: article.newsId
                        };
                    });
                    return articles;
                }).catch(function(err) {
                    (0,_log__WEBPACK_IMPORTED_MODULE_10__/* .printError */ .O)(err);
                    return null;
                })
            ];
        });
    });
    return function getNpStartupFloatingBanner() {
        return _ref.apply(this, arguments);
    };
}();
var notPublishedYet = function(publishedAt) {
    var now = (0,_date__WEBPACK_IMPORTED_MODULE_9__/* .dateInJST */ .WU)();
    var publishedDateTime = new Date(publishedAt);
    return now < publishedDateTime;
};
var getContentType = function(item) {
    var ref;
    return (ref = item.sys.contentType) === null || ref === void 0 ? void 0 : ref.sys.id;
};
var filterPublished = function(entries) {
    return entries.filter(function(entry) {
        return entry.fields;
    });
};


/***/ }),

/***/ 9427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AP": function() { return /* binding */ convertArticle; },
/* harmony export */   "I2": function() { return /* binding */ fetchPreviewArticle; },
/* harmony export */   "K3": function() { return /* binding */ lockTypeOf; },
/* harmony export */   "U4": function() { return /* binding */ permittedToRead; },
/* harmony export */   "V8": function() { return /* binding */ fetchArticle; },
/* harmony export */   "Zt": function() { return /* binding */ fetchArticles; },
/* harmony export */   "np": function() { return /* binding */ contentBodyOf; },
/* harmony export */   "nz": function() { return /* binding */ fetchArticlesTotalCount; },
/* harmony export */   "wB": function() { return /* binding */ fetchArticlesByKeyword; }
/* harmony export */ });
/* unused harmony exports hasLimitMarker, isArticle */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70655);
/* harmony import */ var _api_contentful__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58585);
/* harmony import */ var _log__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79240);
/* harmony import */ var _url__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48261);
/* harmony import */ var _user__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73650);








var fetchArticles = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var cursor, limit, articles, data, e;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    cursor = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : 0, limit = _arguments.length > 1 ? _arguments[1] : void 0;
                    articles = [];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0,_api_contentful__WEBPACK_IMPORTED_MODULE_0__/* .getArticles */ .Zz)(cursor, limit)
                    ];
                case 2:
                    data = _state.sent();
                    if (data) {
                        articles = data.items.map(function(res) {
                            return convertArticle((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, res.fields), {
                                id: res.sys.id
                            }));
                        });
                    }
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    (0,_log__WEBPACK_IMPORTED_MODULE_7__/* .printError */ .O)(e);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2,
                        articles
                    ];
            }
        });
    });
    return function fetchArticles() {
        return _ref.apply(this, arguments);
    };
}();
var fetchArticlesByKeyword = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(keyword) {
        var articles, data, e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    articles = [];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0,_api_contentful__WEBPACK_IMPORTED_MODULE_0__/* .getArticlesByKeyword */ .AU)(keyword)
                    ];
                case 2:
                    data = _state.sent();
                    if (data) {
                        articles = data.items.map(function(res) {
                            return convertArticle((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, res.fields), {
                                id: res.sys.id
                            }));
                        });
                    }
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    (0,_log__WEBPACK_IMPORTED_MODULE_7__/* .printError */ .O)(e);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2,
                        articles
                    ];
            }
        });
    });
    return function fetchArticlesByKeyword(keyword) {
        return _ref.apply(this, arguments);
    };
}();
var fetchArticlesTotalCount = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var total, data, e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    total = 0;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0,_api_contentful__WEBPACK_IMPORTED_MODULE_0__/* .getArticles */ .Zz)()
                    ];
                case 2:
                    data = _state.sent();
                    if (data) {
                        total = data.total;
                    }
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    (0,_log__WEBPACK_IMPORTED_MODULE_7__/* .printError */ .O)(e);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2,
                        total
                    ];
            }
        });
    });
    return function fetchArticlesTotalCount() {
        return _ref.apply(this, arguments);
    };
}();
var fetchArticle = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(slugOrId) {
        var article, contetnfulArticle, e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,_api_contentful__WEBPACK_IMPORTED_MODULE_0__/* .getArticle */ .fq)(slugOrId)
                    ];
                case 1:
                    contetnfulArticle = _state.sent();
                    if (contetnfulArticle) {
                        article = convertArticle(contetnfulArticle);
                    }
                    return [
                        3,
                        3
                    ];
                case 2:
                    e = _state.sent();
                    (0,_log__WEBPACK_IMPORTED_MODULE_7__/* .printError */ .O)(e);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2,
                        article
                    ];
            }
        });
    });
    return function fetchArticle(slugOrId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchPreviewArticle = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(id) {
        var article, contetnfulArticle, e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,_api_contentful__WEBPACK_IMPORTED_MODULE_0__/* .getPreviewArticle */ .ex)(id)
                    ];
                case 1:
                    contetnfulArticle = _state.sent();
                    if (contetnfulArticle) {
                        article = convertArticle(contetnfulArticle);
                    }
                    return [
                        3,
                        3
                    ];
                case 2:
                    e = _state.sent();
                    (0,_log__WEBPACK_IMPORTED_MODULE_7__/* .printError */ .O)(e);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2,
                        article
                    ];
            }
        });
    });
    return function fetchPreviewArticle(id) {
        return _ref.apply(this, arguments);
    };
}();
var convertArticle = function(article, isRelatedArticle) {
    var reportFile = article.reportFile ? {
        url: (0,_url__WEBPACK_IMPORTED_MODULE_1__/* .withProtocol */ .Ac)(article.reportFile.fields.file.url),
        title: article.reportFile.fields.title
    } : undefined;
    var headerImage = {
        url: (0,_url__WEBPACK_IMPORTED_MODULE_1__/* .withProtocol */ .Ac)(article.headerImage.fields.file.url),
        title: article.headerImage.fields.title
    };
    var pickupImage = article.pickupImage && {
        url: (0,_url__WEBPACK_IMPORTED_MODULE_1__/* .withProtocol */ .Ac)(article.pickupImage.fields.file.url),
        title: article.pickupImage.fields.title
    };
    // NOTE: 相互に関連記事になっている場合に無限ループとなるため
    var relatedArticles = isRelatedArticle ? [] : article.relatedArticles && (0,_api_contentful__WEBPACK_IMPORTED_MODULE_0__/* .filterPublished */ .re)(article.relatedArticles).map(function(a) {
        return convertArticle((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, a.fields), {
            id: a.sys.id
        }), true);
    });
    var newTags = article.newTags && (0,_api_contentful__WEBPACK_IMPORTED_MODULE_0__/* .filterPublished */ .re)(article.newTags).map(function(tag) {
        return {
            name: tag.fields.name,
            sfdcId: tag.fields.sfdcId,
            slug: tag.fields.slug
        };
    });
    var companies = article.companies && (0,_api_contentful__WEBPACK_IMPORTED_MODULE_0__/* .filterPublished */ .re)(article.companies).map(function(company) {
        return {
            shortname: company.fields.shortname,
            name: company.fields.name
        };
    });
    var investors = article.investors && (0,_api_contentful__WEBPACK_IMPORTED_MODULE_0__/* .filterPublished */ .re)(article.investors).map(function(investor) {
        return {
            shortname: investor.fields.shortname,
            name: investor.fields.name
        };
    });
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, article), {
        headerImage: headerImage,
        pickupImage: pickupImage,
        relatedArticles: relatedArticles,
        newTags: newTags,
        companies: companies,
        investors: investors,
        reportFile: reportFile,
        scope: article.scope
    });
};
// NOTE: Actual impl. has hard-coded role (`enterprise`).
var limitMarker = /<!--\s*?limit: enterprise\s*?-->[^]+/;
var hasLimitMarker = function(text) {
    return limitMarker.test(text);
};
var contentBodyOf = function(text, options) {
    return options.permitted ? text : hasLimitMarker(text) ? text.replace(limitMarker, "") : "";
};
var permittedToRead = function(user, article) {
    switch(article.scope){
        case "all":
            return true;
        case "enterprise":
            return (0,_user__WEBPACK_IMPORTED_MODULE_2__/* .isTrial */ .pN)(user) || (0,_user__WEBPACK_IMPORTED_MODULE_2__/* .isEnterprise */ .ko)(user) && (0,_user__WEBPACK_IMPORTED_MODULE_2__/* .isLatestPlan */ .br)(user);
    }
    // Fallback: Enterprise users can read all anyway.
    console.warn("Unexpected scope: ".concat(article.scope));
    return (0,_user__WEBPACK_IMPORTED_MODULE_2__/* .isEnterprise */ .ko)(user) && (0,_user__WEBPACK_IMPORTED_MODULE_2__/* .isLatestPlan */ .br)(user);
};
var lockTypeOf = function(user, article) {
    if (article.scope === "all") {
        return "none";
    }
    return permittedToRead(user, article) ? "unlocked" : "locked";
};
var isArticle = function(content) {
    return content.scope !== undefined;
};


/***/ }),

/***/ 24654:
/***/ (function() {

/* (ignored) */

/***/ })

}]);